import { Grid } from '@material-ui/core';
import { Icon, Upload, DatePicker, Spin, Result, Button, Divider, message } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { fetchAttachment, attachmentClear } from "app/actions/AttachmentActions";
import { getAttachment } from "app/reducers";
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApiService from 'app/services/ApiService';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';
import * as XLSX from 'xlsx/xlsx.mjs';
import { read } from 'xlsx';
import {
    postEmployeeLayout,
} from 'app/actions/CommunicationProgramActions';


export default function AttachFileContainer(props) {

    const [dataExcel, setDataExcel] = useState([]);
    const dispatch = useDispatch();
    const [validDoc, setValidDoc] = useState(true)
    const reader = new FileReader();
    const { Dragger } = Upload;
    const courseAttachment = useSelector(getAttachment);
    const [fileXLSX, setFileXLSX] = useState(undefined);
    const [state, setState] = useState({
        fileList: [],
        finishedOrError: false,
        typeDoc: true,
        loadStatus: 'initial',
        iconName: {
            'initial': 'cloud-upload',
            'loading': 'loading',
            'success': 'smile',
            'error': 'frown',
        },
        fileName: '',
        pdf: '',
        url: '',
        numPages: null,
        pageNumber: 1

    })
    const params = props.children({ state, courseAttachment });
    const fetchCourseAttachmentAction = () => dispatch(fetchAttachment(state.idCourse));

    useEffect(() => {
        if (props.localAttachment === undefined && isEmpty(courseAttachment)) {
            //fetchCourseAttachmentAction();
        } else if (props.localAttachment !== undefined) {
            state.url = props.localAttachment
        }
    }, []);

    useEffect(() => {
        props.setDataExcel(dataExcel);
    }, [dataExcel])

    // useEffect(() => {
    //     dispatch(uploadFile());
    // }, [fileXLSX])

    const {
        siteId
    } = useSelector(state => state.Auth)

    const actions = {
        multiple: false,
        onRemove: file => {
            const index = state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            setState({ ...state, fileList: newFileList })
            setDataExcel([]);
        },
        beforeUpload: file => {
            setState({ ...state, fileList: [] })
            state.fileList = [file];
            state.isLoading = true;
            createFile(state.fileList);
            return false

            // setFileXLSX(file)

            // return false
        },
        state,
    };

    const createFile = (file) => new Promise(async (resolve, reject) => {
        setState({ ...state, loadStatus: 'loading' });
        if (file[0]) {
            const formData = new FormData();
            formData.append('fileName', file[0]);

            await ApiService.validateEmployeeTemplate(props.idCourse, formData)
                .then(response => {
                    let { data } = response;
                    if(response.message !== ""){
                        message.error(`${response.message}`);
                        setState({ ...state, loadStatus: 'initial' });
                    }else{
                        var jsonData = data.map((x, index)=> {
                            return {
                                key: x.employeeId,
                                fullName: x.name,
                                employeeId: x.employeeId,
                                category: x.category,
                                companyName: x.companyName
                            }
                        })
                        setDataExcel(jsonData)
                        setState({ ...state, loadStatus: 'success' });
                    }
                   
                })
                .catch(error => {
                  
                    message.error("Ocurrio un error al verificar la información, favor de interntarlo nuevamente");
                    setState({ ...state, loadStatus: 'initial' });
                })
        }

    });

    const migrateData = async (dataFile) => {


    }


    const draggerText = {
        Text: function () {
            return (
                <div>
                    <p className="ant-upload-drag-icon">
                        <Icon type={state.iconName[state.loadStatus]} />
                    </p>
                    <p className="ant-upload-text">
                        {state.loadStatus === 'initial' ? 'Selecciona o arrastra un archivo' : 'Leyendo archivo...'}
                    </p>
                    <p className="ant-upload-hint">
                        {state.loadStatus === 'initial' ? 'Únicamente formatos .xlsx' : ''}
                    </p>
                </div>
            )
        },
        finishedText: function () {
            return (
                <div>
                    <p className="ant-upload-drag-icon">
                        <Icon type={state.iconName[state.loadStatus]} />
                    </p>
                    <p className="ant-upload-text">
                        {state.loadStatus === 'success' ? 'Carga de Archivo exitosa!' : 'Ops! ocurrio un error, intente nuevamente.'}
                    </p>
                </div>
            )
        }
    }

    const converBase64toBlob = (content, contentType) => {
        contentType = contentType || '';
        var sliceSize = 512;
        var byteCharacters = window.atob(content); //method which converts base64 to binary
        var byteArrays = [
        ];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, {
            type: contentType
        }); //statement which creates the blob
        return blob;
    }

    const getfile = (base64) => {
        state.pdf = base64;
        let file = converBase64toBlob(base64, 'application/pdf');
        const blob = new Blob([file], { type: 'application/pdf' });
        state.url = URL.createObjectURL(blob);
        props.setAttachment(state.url);
        setState({ ...state, url: URL.createObjectURL(blob) })
        props.setLoadDocument(true);
    }

    if (Object.keys(courseAttachment).length !== 0) {
        if (state.pdf === '' && props.localAttachment === undefined) {
            getfile(courseAttachment.Data[0].attachmentFile);
        }
    }


    return params && (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Dragger {...actions} disabled={state.loadStatus !== 'initial' || siteId !== 'HUB'} accept={'.xlsx'} fileList={state.fileList} >
                        {state.loadStatus === 'initial' || state.loadStatus === 'loading' ? <draggerText.Text /> : <draggerText.finishedText />}
                    </Dragger>
                    <div>
                        <p className="ant-upload-text">
                            {!validDoc ? 'La extensión de archivo no es válida' : null}
                        </p>
                    </div>
                </Grid>
                {/* <Divider /> */}
            </Grid>
        </div>
    );
}



